import { render, staticRenderFns } from "./NewBook.vue?vue&type=template&id=f1b8ba48&scoped=true"
var script = {}
import style0 from "./NewBook.vue?vue&type=style&index=0&id=f1b8ba48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b8ba48",
  null
  
)

export default component.exports